export const SEPARATOR = "~";

export const CURRENCY_LIST = [
  {
    label: "USD",
    value: "$",
  },
  {
    label: "EUR",
    value: "€",
  },
  {
    label: "GBP",
    value: "€",
  },
  {
    label: "JPY",
    value: "€",
  },
  {
    label: "CAD",
    value: "€",
  },
  {
    label: "AUD",
    value: "€",
  },
];

export const TOASTER_ALIGNMENT_TOP = "bottom";
export const TOASTER_ALIGNMENT_HORIZONTAL = "right";
export const FORM_TYPE_MAIN = "mainform";
export const FORM_TYPE_SHIPMENT = "shipment";
export const FORM_TYPE_SHIPMENT_INVENTORY = "shipmentinventory";
export const FORM_TYPE_QMU = "qmu";
export const FORM_TYPE_INVENTORY = "inventory";
export const FORM_TYPE_QMU_OER = "qmu_oer";
export const REOPEN_MESSAGE =
  "This case has been reopened. Please click Ok to refresh page.";
export const CDK_APPROVE = "APPROVE"; // CDK: Confirm Dialog Key;
export const COUNTRY_NOT_APPLICABLE = "701";
export const REQUEST_FOR_CLOSE_MESSAGE =
  "A request has been sent to close the case";
export const DATA_SAVE_SUCCESS = "Data saved successfully";
export const FORM_ERROR_MESSAGE =
  "Please correct validation errors on the screen";
export const MAX_LENGTH_50 = 50;
export const MAX_LENGTH_20 = 20;
export const MAX_LENGTH_200 = 200;
export const MAX_LENGTH_100 = 100;
export const CDK_CLOSE_BTN = "CLOSE_BTN";


 export const NEW_USER = {
  ROLE: {
    ADMIN: "Admin",
    QMU: "QMU",
    INS: "INS",
    FMC: "FMC",
    UNICEF: "UNICEF",
    PARTNER: "Partner",
    SOLUTION_OWNER: "Solution Owner",
    SOLUTION_TEAM: "Solution Team"
  },
};

export const CommonConstant = {
  SHOW_TOSTER_TIME_INTERVEL: 6000,
  SHOW_TOSTER_MESSAGE_TIME_INTERVEL: 10000,
  SUCCESS: "SUCCESS",
  SHOW_TOSTER_TIME_INTERVEL_LESS: 1500,
};

export const AdminContactMail = window.AdminContactMail;